<div class="page-not-found">
  <app-ice-card>
    <div class="page-not-found-card">
      <mat-icon class="page-not-found-icon" [svgIcon]="IconNames.ice_worried" />
      <div>Siden du forsøker å nå finnes ikke</div>
      <div>
        <a data-testid="back-to-main-page-link" [routerLink]="diegoRoutes.startSale">Tilbake til hovedsiden</a>
      </div>
    </div>
  </app-ice-card>
</div>
